import { render, staticRenderFns } from "./ProductsVariantForm.vue?vue&type=template&id=0edc0483&scoped=true&"
import script from "./ProductsVariantForm.vue?vue&type=script&lang=js&"
export * from "./ProductsVariantForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductsVariantForm.vue?vue&type=style&index=0&id=0edc0483&lang=scss&scoped=true&"
import style1 from "./ProductsVariantForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edc0483",
  null
  
)

export default component.exports